import {html,ref} from '@genesislcap/web-core';
import type {HelpMenu} from './help-menu';


export const HelpMenuTemplate = html<HelpMenu>`
  <rapid-icon @click=${x=> x.showHelp()} name="circle-question" size="sm"></rapid-icon>
  <help-dialog id="help-dialog" ${ref('helpDialog')}></help-dialog>
`;
